/* eslint-disable max-len */
import { defineMessages } from 'react-intl';

export default defineMessages({

    // Page Header
    // Added
    TitleSmi: {
        id: 'qnb.smi.IpidPage.TitleSmi',
        defaultMessage: 'Saga Health Insurance'
    },
    SubTitleIPID: {
        id: 'qnb.smi.IpidPage.SubTitleIPID',
        defaultMessage: 'Insurance Product Information Document'
    },
    SubTitleCompany: {
        id: 'qnb.smi.IpidPage.SubTitleCompany',
        defaultMessage: 'Company: Saga Services Limited'
    },
    SubTitleProduct: {
        id: 'qnb.smi.IpidPage.SubTitleProduct',
        defaultMessage: 'Product: {product}'
    },
    HeaderAdditionalParagraph: {
        id: 'qnb.smi.IpidPage.HeaderAdditionalParagraph',
        defaultMessage: 'Saga Services Limited has arranged for its health insurance to be underwritten by Bupa Insurance Limited. Registered Office: 1 Angel Court, London EC2R 7HJ. Registered in England and Wales No. 3956433. Financial Services Register No. 203332.'
    },

    // Product types
    ProductSuper: {
        id: 'qnb.smi.IpidPage.ProductSuper',
        defaultMessage: 'HealthPlan Super'
    },
    ProductSecure: {
        id: 'qnb.smi.IpidPage.ProductSecure',
        defaultMessage: 'HealthPlan Secure'
    },
    ProductSaverPlus: {
        id: 'qnb.smi.IpidPage.ProductSaverPlus',
        defaultMessage: 'HealthPlan SaverPlus'
    },
    ProductSuper4: {
        id: 'qnb.smi.IpidPage.ProductSuper4',
        defaultMessage: 'HealthPlan Super 4'
    },
    ProductSecure4: {
        id: 'qnb.smi.IpidPage.ProductSecure4',
        defaultMessage: 'HealthPlan Secure 4'
    },
    ProductSaverPlus4: {
        id: 'qnb.smi.IpidPage.ProductSaverPlus4',
        defaultMessage: 'HealthPlan SaverPlus 4'
    },
    WhatIsTheTypeOfInsurance: {
        id: 'qnb.smi.IpidPage.SubHeaderP3',
        defaultMessage: 'Your Saga Health Insurance policy is designed to provide you with quick access to see a specialist and receive eligible private medical treatment when you need it.'
    },

    //    What is insured?
    //    Common
    IPAndDPTreatmentTitle: {
        id: 'qnb.smi.IpidPage.IPAndDPTreatmentTitle',
        defaultMessage: 'Inpatient and day patient treatment'
    },
    IPDPHospitalCharges: {
        id: 'qnb.smi.IpidPage.IPDPHospitalCharges',
        defaultMessage: 'Inpatient and day patient charges for treatment in a hospital listed in the Saga Countrywide Hospital List and specialist fees from a specialist on our ‘fee-assured’ list - no annual maximum.'
    },
    RadioChemoTherapy: {
        id: 'qnb.smi.IpidPage.RadioChemoTherapy',
        defaultMessage: 'Cancer treatment, including radiotherapy and chemotherapy.'
    },
    HospitalMentalHealthTreatmentCharges: {
        id: 'qnb.smi.IpidPage.HospitalMentalHealthTreatmentCharges',
        defaultMessage: 'Up to 28 days hospital charges for mental health treatment, when treatment is in a hospital listed in the Saga Countrywide Hospital List.'
    },
    OutPatientTreatmentTitle: {
        id: 'qnb.smi.IpidPage.OutPatientTreatmentTitle',
        defaultMessage: 'Outpatient treatment'
    },
    OPSurgery: {
        id: 'qnb.smi.IpidPage.OPSurgery',
        defaultMessage: 'Surgical procedures - no annual maximum.'
    },
    OPConsultations: {
        id: 'qnb.smi.IpidPage.OPConsultations',
        defaultMessage: 'Specialist consultations, diagnostic tests, practitioner, therapists’, physiotherapists’ and, acupuncturists charges - paid up to £{amountOPConsultations}.'
    },
    OPCancerDiagnosisNoAnnualMax: {
        id: 'qnb.smi.IpidPage.OPCancerDiagnosisNoAnnualMax',
        defaultMessage: 'Eligible outpatient treatment following the diagnosis of cancer - no annual maximum.'
    },
    CTMRIPETPaidInFull: {
        id: 'qnb.smi.IpidPage.CTMRIPETPaidInFull',
        defaultMessage: 'CT, MRI and PET scans - paid in full.'
    },
    OPYearConsultations: {
        id: 'qnb.smi.IpidPage.OPYearConsultations',
        defaultMessage: 'Up to £{amountOPYearConsultations} a year for outpatient specialist consultations and diagnostics tests for mental health treatment.'
    },
    OtherBenefitsTitle: {
        id: 'qnb.smi.IpidPage.OtherBenefitsTitle',
        defaultMessage: 'Other benefits'
    },
    NHSCashBenefit: {
        id: 'qnb.smi.IpidPage.NHSCashBenefit',
        defaultMessage: 'NHS cash benefit of £{amountPerNight} per night for up to £{maxAmountPerYear} per year.'
    },
    ExtProsthesisLifeTime: {
        id: 'qnb.smi.IpidPage.ExtProsthesisLifeTime',
        defaultMessage: 'Up to £5,000 for the lifetime of the policy towards the cost of an external prosthesis.'
    },
    AccessToSagaGP: {
        id: 'qnb.smi.IpidPage.AccessToSagaGP',
        defaultMessage: '24/7 access to the Saga GP Service.'
    },
    WorkingBodyService: {
        id: 'qnb.smi.IpidPage.WorkingBodyService',
        defaultMessage: 'MSK Direct Access – for muscle, bone or joint pain you can speak to a physiotherapist over the phone without needing a GP referral.'
    },
    MentalHealthSupport: {
        id: 'qnb.smi.IpidPage.MentalHealthSupport',
        defaultMessage: 'Counselling through Mental Health Direct Access Support service.'
    },
    CancerCareTeamSupport: {
        id: 'qnb.smi.IpidPage.CancerCareTeamSupport',
        defaultMessage: 'Cancer Care Team support -access to a dedicated team of cancer nurses.'
    },

    //    SaverPlus
    CTMRIPETOnePerYear: {
        id: 'qnb.smi.IpidPage.CTMRIPETonePerYear',
        defaultMessage: 'One CT, MRI or PET scan - per year.'
    },
    CTMRIPETFollowUp: {
        id: 'qnb.smi.IpidPage.CTMRIPETFollowUp',
        defaultMessage: 'Unlimited follow-up CT, MRI and PET scans performed within eight months after related, eligible inpatient or day patient treatment, or after a related eligible outpatient surgical procedure.'
    },

    //    Secure specific
    PostOperativeTherapies: {
        id: 'qnb.smi.IpidPage.PostOperativeTherapies',
        defaultMessage: 'Up to an additional £400 cover for post operative therapies, physiotherapists\', and acupuncturists\' charges.'
    },
    RecuperativeCareSecure: {
        id: 'qnb.smi.IpidPage.RecuperativeCareSecure',
        defaultMessage: 'Up to £1,000 for recuperative care following eligible inpatient treatment, for up to 30 days a year.'
    },

    //    Super specific
    OPConsultationsNoAnnualMaximum: {
        id: 'qnb.smi.IpidPage.OPConsultationsNoAnnualMaximum',
        defaultMessage: 'Specialist consultations, diagnostic tests, practitioners\' and physiotherapists’ charges paid - no annual maximum.'
    },
    YearTherapistCharges: {
        id: 'qnb.smi.IpidPage.YearTherapistCharges',
        defaultMessage: 'Up to £2,000 a year for therapists’ and acupuncturists’ charges.'
    },
    RecuperativeCareSuper: {
        id: 'qnb.smi.IpidPage.RecuperativeCareSuper',
        defaultMessage: 'Up to £2,000 for recuperative care following eligible inpatient treatment, for up to 30 days a year.'
    },
    DentalCashBenefit: {
        id: 'qnb.smi.IpidPage.DentalCashBenefit',
        defaultMessage: 'Major dental cash benefit for specified dental procedures up to £1,500.'
    },
    DentalInjuriesBenefit: {
        id: 'qnb.smi.IpidPage.DentalInjuriesBenefit',
        defaultMessage: 'Dental injuries benefit of up to £5,000 a year.'
    },
    MentalHealthTreatment: {
        id: 'qnb.smi.IpidPage.MentalHealthTreatment',
        defaultMessage: 'Up to 28 days a year for inpatient mental health treatment when treatment is in a hospital listed in the Saga Countrywide Hospital List.'
    },
    WhereIncludedTitle: {
        id: 'qnb.smi.IpidPage.WhereIncludedTitle',
        defaultMessage: 'Where Included'
    },
    //    NCD Protection added
    NCDIncludedTitle: {
        id: 'qnb.smi.IpidPage.NCDIncludedTitle',
        defaultMessage: 'No Claims Discount Protection'
    },
    NCDIncluded: {
        id: 'qnb.smi.IpidPage.NCDIncluded',
        defaultMessage: 'Enables you to make one claim during the previous NCD year, and remain on the same No Claim Discount level.'
    },
    //    Health Cash Benefits added
    HealthCashBenefitsTitle: {
        id: 'qnb.smi.IpidPage.HealthCashBenefitsTitle',
        defaultMessage: 'Health Cash Benefits Cover'
    },
    HealthCashBenefits: {
        id: 'qnb.smi.IpidPage.HealthCashBenefits',
        defaultMessage: 'Cashback for dentist and optician fees or a health assessment.'
    },
    //    Extended Cancer Cover added
    ExtendedCancerCoverTitle: {
        id: 'qnb.smi.IpidPage.ExtendedCancerCoverTitle',
        defaultMessage: 'Extended Cancer Cover'
    },
    ExtendedCancerCover1: {
        id: 'qnb.smi.IpidPage.ExtendedCancerCover1',
        defaultMessage: 'Cancer drug treatment to prevent recurrence and maintain remission.'
    },
    ExtendedCancerCover2: {
        id: 'qnb.smi.IpidPage.ExtendedCancerCover2',
        defaultMessage: 'Cancer related palliative or end of life treatment.'
    },
    ExtendedCancerCover3: {
        id: 'qnb.smi.IpidPage.ExtendedCancerCover3',
        defaultMessage: 'No time limits on the use of eligible drug treatments available for cancer.'
    },
    ExtendedCancerCover4: {
        id: 'qnb.smi.IpidPage.ExtendedCancerCover4',
        defaultMessage: 'Hospital expenses cash benefit, and benefit for wigs, external prosthesis and a hospice donation.'
    },
    //    Pre-Existing Hypertension Cover added
    PreExistingHypertensionCoverTitle: {
        id: 'qnb.smi.IpidPage.PreExistingHypertensionCoverTitle',
        defaultMessage: 'Pre-Existing Hypertension Cover'
    },
    PreExistingHypertensionCover1: {
        id: 'qnb.smi.IpidPage.PreExistingHypertensionCover1',
        defaultMessage: 'Cover for pre-existing hypertension.'
    },

    // What is not insured
    NotInsured1: {
        id: 'qnb.smi.IpidPage.NotInsured1',
        defaultMessage: 'The excess amount shown in your Policy Schedule which is applicable once per person per policy year.'
    },
    NotInsured2: {
        id: 'qnb.smi.IpidPage.NotInsured2',
        defaultMessage: 'Pregnancy and childbirth.'
    },
    NotInsured3: {
        id: 'qnb.smi.IpidPage.NotInsured3',
        defaultMessage: 'Treatment that we have not first authorised as eligible.'
    },
    NotInsured4: {
        id: 'qnb.smi.IpidPage.NotInsured4',
        defaultMessage: 'Treatment for ongoing, recurrent and long-term conditions (also known as chronic conditions).'
    },
    NotInsured5: {
        id: 'qnb.smi.IpidPage.NotInsured5',
        defaultMessage: 'The Moratorium underwriting method excludes the treatment of any pre-existing conditions you had during the three years immediately before your policy started and, in some cases, other specified conditions associated with the pre-existing condition (if anyone on the policy has chosen the Full Medical Underwriting (FMU) or Continued Personal Medical Exclusions (CPME) underwriting methods, any underwriting terms or exclusions will be listed in the Policy Schedule).'
    },
    NotInsured6: {
        id: 'qnb.smi.IpidPage.NotInsured6',
        defaultMessage: 'Dental Procedures unless you have Health Cash Benefits Cover.'
    },
    NotInsured7: {
        id: 'qnb.smi.IpidPage.NotInsured7',
        defaultMessage: 'Dental Procedures other than the major dental cash benefit, the dental injuries benefit, or Health Cash Benefits Cover.'
    },
    NotInsured8: {
        id: 'qnb.smi.IpidPage.NotInsured8',
        defaultMessage: 'Fees for treatment with specialists we do not recognise.'
    },
    NotInsured9: {
        id: 'qnb.smi.IpidPage.NotInsured9',
        defaultMessage: 'Fees for outpatient drugs or dressings.'
    },
    NotInsured10: {
        id: 'qnb.smi.IpidPage.NotInsured10',
        defaultMessage: 'Fees for services that would normally be carried out by a GP practice, dentist or optician, unless you have the Health Cash Benefits Cover Option.'
    },

    //  Where am I covered?
    WhereAmICovered: {
        id: 'qnb.smi.IpidPage.WhereAmICovered',
        defaultMessage: 'United Kingdom'
    },

    //    What are my Obligations?
    MyObligations1: {
        id: 'qnb.smi.IpidPage.MyObligations1',
        defaultMessage: 'You must give complete and accurate answers to any questions Saga and Bupa may ask, and inform us if anything changes between the time you join and the start date of your policy, or within the policy year.'
    },
    MyObligations2: {
        id: 'qnb.smi.IpidPage.MyObligation2',
        defaultMessage: 'When your GP decides you need to see a specialist and you want to make a claim, you must ask for an open referral so our team can help you book appointments with a suitable specialist.'
    },

    //    Are there any restrictions on cover?
    Restrictions1: {
        id: 'qnb.smi.IpidPage.Restrictions1',
        defaultMessage: 'MSK Direct Access is available to members aged 12 or over. Mental Health Direct Access is available to members aged 18 or over.'
    },
    Restrictions2: {
        id: 'qnb.smi.IpidPage.Restrictions2',
        defaultMessage: 'If there is an excess, we will deduct this amount from the first claim(s) for each person per policy year.'
    },
    Restrictions3: {
        id: 'qnb.smi.IpidPage.Restrictions3',
        defaultMessage: 'There is no cover for inpatient or day patient treatment, or for a surgical procedure performed as an outpatient, that the NHS can provide within 4 weeks of when you need it.'
    },
    Restrictions3a: {
        id: 'qnb.smi.IpidPage.Restrictions3a',
        defaultMessage: 'There is no cover for inpatient or day patient treatment that the NHS can provide within 4 weeks of when you need it.'
    },
    Restrictions4: {
        id: 'qnb.smi.IpidPage.Restrictions4',
        defaultMessage: 'Cover is restricted to treatment received at a facility on our Countrywide Hospital List (including the London upgrade list if selected), unless otherwise pre-authorised by us.'
    },
    Restrictions5: {
        id: 'qnb.smi.IpidPage.Restrictions5',
        defaultMessage: 'This policy includes Saga Guided Care and the following applies: When you require treatment we will support you by choosing a selected provider to treat you. To enable us to do this you should contact the Claims Helpline before booking or receiving any treatment.'
    },
    Restrictions5_1: {
        id: 'qnb.smi.IpidPage.Restrictions5_1',
        defaultMessage: 'If selected, Extended Cancer Cover, Health Cash Benefits, and cover for pre-existing hypertension will not always apply to everyone insured on the policy. Please refer to the Schedule for confirmation of who is covered.'
    },
    Restrictions6: {
        id: 'qnb.smi.IpidPage.Restrictions6',
        defaultMessage: 'Health Cash Benefits Cover is restricted to:'
    },
    Restrictions7: {
        id: 'qnb.smi.IpidPage.Restrictions6a',
        defaultMessage: 'Up to £200 per person per year for each of the following: Dental Care, Dental Accident, Dental Emergency.'
    },
    Restrictions8: {
        id: 'qnb.smi.IpidPage.Restrictions6b',
        defaultMessage: 'Up to £150 per person per year for each of the following: Optical Care, Health Assessment.'
    },
    Restrictions9: {
        id: 'qnb.smi.IpidPage.Restrictions7',
        defaultMessage: 'Cover under Extended Cancer Cover, Health Cash Benefits, and for pre-existing hypertension is only applicable if selected.'
    },

    //    When and how do I pay?
    WhenAndHowDoIPay: {
        id: 'qnb.smi.IpidPage.WhenAndHowDoIPay',
        defaultMessage: 'We offer a choice of monthly or annual payments which can be paid by Direct Debit. In addition, we offer a choice of annual payments which can be paid by cheque, debit or credit card. Payment will be taken when you take out the policy.'
    },
    WhenAndHowDoIPayWithQuarterly: {
        id: 'qnb.smi.IpidPage.WhenAndHowDoIPayWithQuarterly',
        defaultMessage: 'We offer a choice of monthly, quarterly or annual payments which can be paid by Direct Debit. In addition, we offer a choice of annual payments which can be paid by cheque, debit or credit card. Payment will be taken when you take out the policy.'
    },
    HowToCancelText: {
        id: 'qnb.smi.IpidPage.HowToCancelText',
        defaultMessage: 'Please contact us by telephone on {phone} or write to us at Saga Services Limited, PO Box 253, Seaham DO, SR7 1BN'
    }
});
